module.exports = __webpack_public_path__ + "229fc3142eb9477aef0ebbcc74aa3058.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Digi/tmt.png
// module id = 1425
// module chunks = 13